import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=2d351a02&"
import script from "./Detailed.vue?vue&type=script&lang=ts&"
export * from "./Detailed.vue?vue&type=script&lang=ts&"
import style0 from "./Detailed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports